<template>
    <div class="input-element__row">
      <v-btn icon :ripple="{ class: 'primary--text' }" @click="disable">
          <v-icon v-if="!checkbox" color="primary">radio_button_unchecked</v-icon>
          <v-icon v-else color="primary">radio_button_checked</v-icon>
      </v-btn>
      <v-text-field
        :label="placeholder"
        :disabled="disabled"
        @change="setValue"
        :value="value | thousands"
        prefix="$"
      />
    </div>
</template>

<script>
  export default {
    data () {
      return {
        checkbox: null,
        validation: [
          v => isNaN(v) || 'Field must be numeric'
        ]
      }
    },
    props: ['placeholder', 'disabled', 'value'],
    mounted () {
      this.checkbox = !this.disabled
    },
    filters: {
      thousands: function (number) {
        if (number === null) return "0.00"
        return Number(number).toFixed(2).toString().toLocaleString()
      }
    },
    methods: {
      setValue (val) {
        val = val.split(',').join('')
        if (isNaN(val)) return false
        this.$emit('changeValueInput', Number(val))
      },
      disable () {
        this.$emit('disable')
      }
    },
    watch: {
      disabled (val) {
        this.checkbox = !val
      }
    }
  }
</script>
<style lang="scss">
  .input-element__row {
    display: flex;
    align-items: center;
  }
</style>
